import { useEffect, useState } from 'react';

// Requests the browser's geolocation once, so the homepage's event
// sections can show what's near the visitor first. `isLocationReady`
// flips to true once we know one way or the other, so callers can wait
// for it before firing their event-fetch request rather than fetching
// once without location and again right after.
//
// Falls back to { latitude: null, longitude: null } - today's unscoped
// behavior, unchanged - whenever geolocation isn't available, the user
// denies the permission prompt, or the request times out.
const useUserLocation = () => {
    const [location, setLocation] = useState({ latitude: null, longitude: null });
    const [isLocationReady, setIsLocationReady] = useState(false);

    useEffect(() => {
        if (!navigator.geolocation) {
            setIsLocationReady(true);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
                setIsLocationReady(true);
            },
            () => {
                // Permission denied / position unavailable / timeout.
                setIsLocationReady(true);
            },
            { timeout: 5000, maximumAge: 10 * 60 * 1000 }
        );
    }, []);

    return { ...location, isLocationReady };
};

export default useUserLocation;
